"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trieste": {
    "737184e0": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trieste"
    }],
    "561dca4b": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trieste"
    }],
    "e5f9ee6b": [{
      "hkey": "967b818a",
      "slug": "trieste",
      "name": "Trieste",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "967b818a",
      "slug": "trieste",
      "name": "Trieste",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42eb1bfa": [{
      "hkey": "42339a99",
      "slug": "borgo-teresiano-giardino-pubblico",
      "name": "Borgo Teresiano-Giardino Pubblico",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "8b5223a5",
      "slug": "chiarbola-san-giacomo",
      "name": "Chiarbola-San Giacomo",
      "primary": false,
      "skipSearch": false
    }, {
      "hkey": "d390a42d",
      "slug": "largo-barriera-settefontane",
      "name": "Largo Barriera-Settefontane",
      "primary": false,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "42339a99",
      "slug": "borgo-teresiano-giardino-pubblico",
      "name": "Borgo Teresiano-Giardino Pubblico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trieste"
    }],
    "de70190e": [{
      "hkey": "5c7c34c8",
      "slug": "opicina-banne",
      "name": "Opicina-Banne",
      "primary": true,
      "skipSearch": false
    }],
    "villa-opicina": [{
      "hkey": "5c7c34c8",
      "slug": "opicina-banne",
      "name": "Opicina-Banne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2ee00e2a": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "zone-di-pregio": [{
      "hkey": "bcd789b4",
      "slug": "citta-vecchia-san-vito",
      "name": "Città Vecchia-San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "trieste"
    }],
    "199de25e": [{
      "hkey": "713c3979",
      "slug": "campanelle-sant-anna-via-costalunga",
      "name": "Campanelle-Sant'Anna-Via Costalunga",
      "primary": true,
      "skipSearch": false
    }],
    "capannelle-sant-anna-via-costalunga": [{
      "hkey": "713c3979",
      "slug": "campanelle-sant-anna-via-costalunga",
      "name": "Campanelle-Sant'Anna-Via Costalunga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fd1bedc9": [{
      "hkey": "8b5223a5",
      "slug": "chiarbola-san-giacomo",
      "name": "Chiarbola-San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "chiarabola-san-giacomo": [{
      "hkey": "8b5223a5",
      "slug": "chiarbola-san-giacomo",
      "name": "Chiarbola-San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;